import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Footer from '@/pages/home/components/Footer';
import { ArticleSchema } from '@/components/base/SchemaOrg';

const SITE_URL = (typeof __VITE_SITE_URL__ !== 'undefined' ? __VITE_SITE_URL__ : 'https://yoybuy.skin') as string;

interface ArticleLayoutProps {
  title: string;
  date: string;
  readTime: string;
  description?: string;
  slug?: string;
  image?: string;
  children: React.ReactNode;
}

declare const __VITE_SITE_URL__: string;

export default function ArticleLayout({ title, date, readTime, description, slug, image, children }: ArticleLayoutProps) {
  const { t } = useTranslation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const articleUrl = slug ? `${SITE_URL}/article/${slug}` : SITE_URL;

  return (
    <main className="pt-14 md:pt-16">
      <ArticleSchema
        headline={title}
        description={description || title}
        datePublished="2026-07-04"
        dateModified="2026-07-04"
        url={articleUrl}
        image={image}
      />
      <article className="bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <nav className="mb-8 text-sm">
            <Link
              to="/"
              className="text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 cursor-pointer inline-flex items-center gap-1.5"
            >
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              Yoybuy Sheet — Главная
            </Link>
          </nav>

          <header className="mb-10">
            <h1 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 leading-tight mb-4">
              {title}
            </h1>
            <div className="flex items-center gap-3 text-foreground-500 text-xs">
              <span>{date}</span>
              <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
              <span>Время чтения: {readTime}</span>
            </div>
          </header>

          <div className="prose-custom text-foreground-700 leading-relaxed space-y-6">
            {children}
          </div>

          <section className="mt-12 pt-8 border-t border-background-200">
            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 text-center">
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">
                Готовы начать экономить с Yoybuy Sheet?
              </h3>
              <p className="text-sm text-foreground-700 mb-5 max-w-md mx-auto">
                Откройте Yoybuy Sheet прямо сейчас на Kaspreadsheet и начните сравнивать shopping-агентов Китая.
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-full transition-all duration-300 text-sm cursor-pointer"
                >
                  <i className="ri-file-excel-2-line w-5 h-5 flex items-center justify-center"></i>
                  {t('btn_yoybuy_sheet')}
                </a>
                <Link
                  to="/"
                  className="whitespace-nowrap inline-flex items-center gap-2 px-7 py-3 border border-foreground-300 text-foreground-700 hover:text-foreground-900 hover:border-foreground-500 font-medium rounded-full transition-all duration-300 text-sm cursor-pointer"
                >
                  <i className="ri-home-line w-5 h-5 flex items-center justify-center"></i>
                  Вернуться на главную
                </Link>
              </div>
            </div>
          </section>
        </div>
      </article>

      <Footer />
    </main>
  );
}